import React from 'react';
import { InputWithUnitField } from '../../../components/Form';
import { useFocusIdx } from 'easy-email-editor';

export function LineHeight({ name }: { name?: string; }) {
  const { focusIdx } = useFocusIdx();

  return (
    <InputWithUnitField
      label='Высота линии'
      unitOptions='percent'
      name={name || `${focusIdx}.attributes.line-height`}
    />
  );
}
